
// 接口文档 http://wiki.linkdoc.com/doku.php?id=tech:%E9%99%A2%E5%86%85%E6%95%B0%E6%8D%AE%E4%B8%AD%E5%BF%83%E4%BA%A7%E5%93%81%E6%8A%80%E6%9C%AF%E6%96%87%E6%A1%A3:%E6%8A%80%E6%9C%AF%E8%AE%BE%E8%AE%A1%E6%96%87%E6%A1%A3:api
import { defineComponent, reactive, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import Modal from 'ant-design-vue/lib/modal';
import { ircLogin, changeIrcPass } from '../services/user';

export default defineComponent({
  setup() {
    const router = useRouter();
    const loginState = reactive({
      username: '',
      password: '',
      fstLogin: false,
      newpass: '',
      newpassagain: '',
      fstInputError: false,
      sedInputError: false,
      showError: false,
      errMsg: '错误提示',
    });

    const isValid = () => {
      if (loginState.username.trim() === '') {
        loginState.errMsg = '请输入用户名';
        loginState.showError = true;
        return false;
      } else if (loginState.password.trim() === '') {
        loginState.errMsg = '请输入密码';
        loginState.showError = true;
        return false;
      }

      if (loginState.fstLogin) {
        if (loginState.newpass.trim() === '') {
          loginState.errMsg = '请输入新密码';
          loginState.showError = true;
          return false;
        } else if (loginState.newpassagain.trim() === '') {
          loginState.errMsg = '请确认新密码';
          loginState.showError = true;
          return false;
        }
      }

      loginState.showError = false;
      return true;
    };

    const login = () => {
      if (!isValid()) return;
      if (loginState.fstLogin) {
        // 如果已经进入修改密码页，点击修改密码按钮调用修改密码接口后跳回登录页
        changeIrcPass({
          old: loginState.password,
          password: loginState.newpass,
          confirm: loginState.newpassagain,
        }).then(res => {
          if (res.data.code === 0) {
            loginState.fstLogin = false;
          }
        });
        return;
      }
      ircLogin({
        username: loginState.username,
        password: loginState.password
      }).then(res => {
        if (res.data.code === 0) {
          // 先清除其他域下同名cookie
          document.cookie = 'user_ticket=; Max-Age=0; path=/; domain=.linkdoc.com';
          const result = res.data.data;
          // 更新cookie
          const d = new Date();
          d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
          document.cookie = 'user_ticket=' + result.apiToken + '; path=/' + '; expires=' + d.toUTCString();
          document.cookie = 'apiToken=' + result.apiToken + '; path=/' + '; expires=' + d.toUTCString();
          document.cookie = 'rememberToken=' + result.rememberToken + '; path=/' + '; expires=' + d.toUTCString();

          router.push('/project/list');
        } else if (res.data.code === 1000) {
          loginState.fstLogin = true;
          loginState.errMsg = '';
        } else {
          loginState.showError = true;
          loginState.errMsg = res.data.message;
        }
      }).catch(({error}) => {
        const data = error.response.data;
        loginState.showError = true;
        loginState.errMsg = data.message || '服务器错误';
      });
    };

    const forgetPassword = () => {
      Modal.warn({
        title: '请联系平台管理员重置密码',
        okText: '确定',
        mask: false,
      });
    };

    return	{
      ...toRefs(loginState),
      login,
      forgetPassword,
    };
  }
});
